/**
 * Training 페이지의 탭 식별 값. 값과 정규화만 두는 leaf 모듈이다.
 */

export const trainingTabSearchParamKey = "tab";

export type TrainingTab = "sessions" | "shares";

export const defaultTrainingTab: TrainingTab = "sessions";
export const shareLinksTabValue: TrainingTab = "shares";

export const trainingTabItems = [
  { value: defaultTrainingTab, label: "Session" },
  { value: shareLinksTabValue, label: "공유 링크" },
] as const;

export function normalizeTrainingTab(value: string | null | undefined): TrainingTab {
  return value === shareLinksTabValue ? shareLinksTabValue : defaultTrainingTab;
}
